import React from 'react';
import Loader from "../../Parts/Loader";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    height: "100px",
    position: "relative",
    width: "100%",
  }
});

const ResultLoaderPanel = props => {
  return (
    <div className={props.classes.root}>
      <Loader type="color" size="large" />
    </div>
  );
}

ResultLoaderPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResultLoaderPanel);



// WEBPACK FOOTER //
// ./src/components/OrderDetail/panels/ResultLoaderPanel.jsx